export default {
  googleFont: "'Inter', sans-serif",
  secondary: "'Inter', sans-serif",
}
